<template>
  <div>
    <loader></loader>
    <no-habilitado v-if="!habilitado" perfil="Arkidians"></no-habilitado>

    <section id="notificaciones">
      <div style="margin-top:100px; margin-bottom:150px">
        <!-- Login Form -->

        <div class="container h-100 d-flex justify-content-center">
          <div class="notificaciones my-auto">
            <h1>Notificaciones</h1>
            <div
              v-if="(notificaciones.length == 0) && (notificacionesVistas.length == 0)"
              style="text-align:center; margin:20px"
            >
              <h3>No hay notificaciones</h3>
              <img
                src="public/images/site/no-challenge.svg"
                style="max-width:300px"
                id="challenges"
                alt="sin actividad"
              />
            </div>

            <div class="modal-body" style="padding:0px">
              <div
                v-for="(notificacion,index) in notificaciones"
                :key="index"
                style="padding:30px 30px"
              >
                <router-link
                  class="commenterImage"
                  :to="'/Perfil/'+notificacion.usuarioRemitente"
                  tag="b"
                  style="cursor:pointer;"
                >
                  <arkidian
                    v-if="notificacion.indicador_visto == 'N'"
                    style="border-style:solid;border-color:#00bf12; border-radius:100%; background:#d8ffdb"
                    :preferencias="notificacion.preferencias"
                  ></arkidian>

                  <arkidian
                    v-if="notificacion.indicador_visto == 'S'"
                    style="border-style:solid;border-color:#bbbbbb; border-radius:100%; background:#cccccc"
                    :preferencias="notificacion.preferencias"
                  ></arkidian>
                </router-link>

                <div class="commentText" style="margin-left:70px">
                  <div v-if="notificacion.tipo_notificacion=='comentario'">
                    <div v-if="notificacion.usuarioRemitente != userLogged.user">
                      <router-link
                        :to="'/Perfil/'+notificacion.usuarioRemitente"
                        tag="b"
                        style="cursor:pointer"
                      ><span style="padding-right:5px">{{notificacion.aliasRemitente}}</span></router-link>dijo de tu
                      <router-link
                        :to="'/Desafio/'+notificacion.idChallenge+'/'+userLogged.user"
                        tag="b"
                        style="cursor:pointer"
                      >desafio:</router-link>
                    </div>

                    <div v-if="notificacion.usuarioRemitente == userLogged.user">
                      Dijiste de tu
                      <router-link
                        :to="'/Desafio/'+notificacion.idChallenge+'/'+userLogged.user"
                        tag="b"
                        style="cursor:pointer"
                      >desafio:</router-link>
                    </div>

                    <i>{{notificacion.mensaje}}</i>
                  </div>

                  <p
                    v-if="notificacion.tipo_notificacion=='like' && notificacion.usuarioRemitente != userLogged.user"
                  >
                    A
                    <router-link
                      :to="'/Perfil/'+notificacion.usuarioRemitente"
                      tag="b"
                      style="cursor:pointer;"
                    ><span style="padding-right:5px">{{notificacion.aliasRemitente}}</span></router-link>le gustó tu
                    <router-link
                      :to="'/Desafio/'+notificacion.idChallenge+'/'+userLogged.user"
                      tag="b"
                      style="cursor:pointer"
                    >desafio:</router-link>
                  </p>

                  <p
                    v-if="notificacion.tipo_notificacion=='like' && notificacion.usuarioRemitente == userLogged.user"
                  >
                    Te gustó tu
                    <router-link
                      :to="'/Desafio/'+notificacion.idChallenge+'/'+userLogged.user"
                      tag="b"
                      style="cursor:pointer"
                    >desafio</router-link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import NoHabilitado from "../shared/NoHabilitado";
import Loader from "../shared/Loader";
import Arkidian from "../shared/Arkidian";

export default {
  data: function() {
    return {
      notificaciones: [],
      notificacionesVistas: [],
      habilitado: false,
      preferencia: {
        color: "",
        body: "",
        face: "",
        hair: "",
        animated: false,
        avatar: ""
      }
    };
  },
  props: ["id"],
  computed: {
    ...mapGetters([
      "categorias",
      "userLogged",
      "pathAPI",
      "usuarioSeleccionado"
    ])
  },
  components: {
    Loader: Loader,
    NoHabilitado: NoHabilitado,
    arkidian: Arkidian
  },
  methods: {
    verNotificaciones() {
      fetch(this.pathAPI + "notificaciones.php?usuario=" + this.userLogged.user)
        .then(response => response.json())
        .then(data => {
          this.notificaciones = [];

          this.notificaciones = data;

          for (var i = 0; i < this.notificaciones.length; i++) {
            if (this.notificaciones[i].arkidian_usuario) {
              this.notificaciones[i].preferencias = {
                color: "fill:#" + this.notificaciones[i].arkidian_usuario.color,
                body: this.notificaciones[i].arkidian_usuario.cuerpo,
                face: this.notificaciones[i].arkidian_usuario.cara,
                hair: this.notificaciones[i].arkidian_usuario.pelo,
                animated: false
              };
            } else {
              this.notificaciones[i].preferencias = {
                avatar: this.notificaciones[i].avatarRemitente
              };
            }
          }
          console.log(this.notificaciones);

          const loader = document.querySelector(".loader");
          loader.className += " hidden";
          this.$store.state.counter = 0;
        });
    },
    marcarNotificacionesVistas() {
      var bodyApi;
      (bodyApi = "usuario=" + this.userLogged.user),
        fetch(this.pathAPI + "notificaciones.php?" + bodyApi, {
          method: "PUT",
          headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
          })
        });
    }
  },
  mounted: function() {
    if (this.userLogged.profile == "HIJO") {
      this.habilitado = true;
      this.verNotificaciones();
      this.marcarNotificacionesVistas();
    } else {
      const loader = document.querySelector(".loader");
      loader.className += " hidden";
    }
  }
};
</script>

<style scoped>
#notificaciones {
  background: url("/public/images/site/background-login.svg");
  background-repeat: repeat-x;
  display: table;
  background-size: 1000px;

  width: 100%;
  background-position-y: top;
}

.notificaciones {
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  background-color: #e9ecef;
  border-radius: 15px;
  -webkit-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
  box-shadow: -1px 20px 71px -39px rgba(0, 0, 0, 0.75);
}

.commenterImage {
  width: 48px;
  margin-right: 5px;
  height: 100%;
  float: left;
}

.commenterImage img {
  width: 100%;
  border-radius: 50%;
}
.commentText p {
  margin: 0;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/sections/Notificaciones.vue